import createImageGalleryApi from './provider';

const NEWS_ITEM_ENTITY_TYPE = 1;

const { get, add, update, remove } = createImageGalleryApi(NEWS_ITEM_ENTITY_TYPE);
export { get, add, update, remove }